export class ApplicationPropertyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getProperties({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/property`);
  }

  async createProperty({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.post(`/application/${applicationId}/property`, body, {
      params: { withLoanOptionId },
    });
  }

  async editProperty({ applicationId, propertyId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/property/${propertyId}`, body, {
      params: { withLoanOptionId },
    });
  }

  async deleteProperty({ applicationId, propertyId, ...params }) {
    return this.#http.delete(`/application/${applicationId}/property/${propertyId}`, { params });
  }

  async updateProperties({ applicationId, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/properties`, body, {
      params: { withLoanOptionId },
    });
  }
}
